import { createFileRoute, Navigate } from '@tanstack/react-router';

import { readFlagBoolean } from '@apps/web/lib/admin_flags';
import { useAdminFlags } from '@apps/web/swr_data_fetching/data_fetching_hooks';
import { type AdminFlag } from '@libraries/typescript/api_client';

export const ADMIN_V3_PLAYGROUND_FLAG_NAME = 'ADMIN_V3_PLAYGROUND_ENABLED';

export function getAdminLandingPath(flag: AdminFlag | undefined) {
    return readFlagBoolean(flag) ? '/admin/agent' : '/admin/agent-traces';
}

export const Route = createFileRoute('/_app/admin/')({
    component: AdminLanding,
});

function AdminLanding() {
    const { data: flags, isLoading } = useAdminFlags();

    if (isLoading) {
        return null;
    }

    const flag = flags?.find(
        ({ name }) => name === ADMIN_V3_PLAYGROUND_FLAG_NAME,
    );
    return <Navigate to={getAdminLandingPath(flag)} replace={true} />;
}
